import { styled } from '@mui/joy';

import {
  Pagination as BasePagination,
  PaginationContent as BasePaginationContent,
  PaginationItem as BasePaginationItem,
  PaginationLink as BasePaginationLink,
  PaginationPrevious as BasePaginationPrevious,
  PaginationNext as BasePaginationNext,
  PaginationEllipsis as BasePaginationEllipsis,
} from './PaginationPrimitives';

const baseItemStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: 0,
  padding: '4px',
  fontSize: '14px',
  fontWeight: 500,
  borderRadius: '3px',
  minWidth: '24px',
  height: '24px',
};

export const Pagination = styled(BasePagination)(() => ({
  display: 'flex',
  width: '100%',
  gap: '12px',
}));

export const PaginationContent = styled(BasePaginationContent)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  listStyle: 'none',
  margin: 0,
  padding: 0,
}));

export const PaginationItem = styled(BasePaginationItem)(() => ({}));
export const PaginationLink = styled(BasePaginationLink)(({ theme, isActive }) => ({
  ...baseItemStyle,
  cursor: 'pointer',
  ...(isActive
    ? {
        backgroundColor: theme.vars.palette.bluePrimary,
        color: 'white',
      }
    : {
        backgroundColor: 'transparent',
        color: theme.vars.palette.grey4,
        '&:hover': {
          backgroundColor: theme.vars.palette.grey2,
        },
      }),
}));

export const PaginationPrevious = styled(BasePaginationPrevious)(({ theme }) => ({
  ...baseItemStyle,
  cursor: 'pointer',
  backgroundColor: 'transparent',

  '& svg': {
    color: theme.vars.palette.grey4,
    fontSize: '20px',
  },
  '&:hover': {
    backgroundColor: theme.vars.palette.grey2,
  },
  '&[disabled]': {
    cursor: 'default',
    pointerEvents: 'none',
    backgroundColor: 'transparent',

    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& svg': {
      color: theme.vars.palette.grey3,
    },
  },
}));

export const PaginationNext = styled(BasePaginationNext)(({ theme }) => ({
  ...baseItemStyle,
  cursor: 'pointer',
  backgroundColor: 'transparent',

  '& svg': {
    color: theme.vars.palette.grey4,
    fontSize: '20px',
  },
  '&:hover': {
    backgroundColor: theme.vars.palette.grey2,
  },
  '&[disabled]': {
    cursor: 'default',
    pointerEvents: 'none',
    backgroundColor: 'transparent',

    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& svg': {
      color: theme.vars.palette.grey3,
    },
  },
}));

export const PaginationEllipsis = styled(BasePaginationEllipsis)(({ theme }) => ({
  ...baseItemStyle,
  marginRight: '8px',
  '& svg': {
    color: theme.vars.palette.grey4,
    fontSize: '14px',
  },
}));
